// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__Gzm7n","inputWrap":"CustomTip_inputWrap__1X-Xy"};